import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <i className="fas fa-tshirt"></i>
              <span>Pompous Touch & Design</span>
            </div>
            <p>Premier fashion design house in Imo State, Nigeria. We create exquisite clothing for all occasions - from ready-to-wear to bespoke designs.</p>
            <div className="social-links">
              <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="#" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">Ready to Wear</a></li>
              <li><a href="#services">Bespoke Tailoring</a></li>
              <li><a href="#services">Bridal Wear</a></li>
              <li><a href="#services">Aseobi & Group Wear</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <span>Tansi, Spibat Owerri, Imo State</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <span>09167110621</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <span>info@pompoustouchdesign.com</span>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Pompous Touch & Design. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;